import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-lead-status',
  imports: [CommonModule,
    
  ],
  templateUrl: './lead-status.component.html',
  styleUrl: './lead-status.component.scss'
})
export class LeadStatusComponent {

  @Input() currentStatus: string = 'Raw';
  @Input() statuses: any[] = [];

  getStatusClass(status: string): string {
    const currentIndex = this.statuses.indexOf(this.currentStatus);
    const statusIndex = this.statuses.indexOf(status);

    if (statusIndex < currentIndex) {
      return 'completed'; // Previous steps (dark)
    } else if (statusIndex === currentIndex) {
      return 'current'; // Current step (yellow)
    } else {
      return 'upcoming'; // Upcoming steps (light)
    }
  }

}
